module.exports = require('./ui/overlays/save-games.template');